import { Component, ElementRef, inject, ViewChild } from '@angular/core';
import { ApiShow } from '@tytapp/api';
import { PageComponent, Transfer } from '@tytapp/common';
import { ShowsService } from '@tytapp/shows';
import { UserService } from '@tytapp/user';

@Component({
    selector: 'tyt-podcasts',
    templateUrl: './podcasts.component.html',
    styleUrls: ['./podcasts.component.scss']
})
export class PodcastsComponent extends PageComponent {
    private userService = inject(UserService);
    private showsService = inject(ShowsService);

    get pageComponentId() {
        return 'podcasts';
    }

    @Transfer()
    shows: ApiShow[];

    @Transfer()
    audienceType: string = 'visitor';

    @Transfer()
    bgImageToUse = '';

    @Transfer()
    topShowId: string;

    @ViewChild('heroImage', { static: true })
    heroImageElement: ElementRef<HTMLElement>;

    hideComponents = false;

    isAboveFold(show: ApiShow) {
        let index = this.shows.indexOf(show);
        let topIndex = this.shows.findIndex(x => x.id === this.topShowId);
        return (index < topIndex);
    }

    async init() {
        console.log('final url: ', this.router.routerState.snapshot.url);
        this.audienceType = this.userService.audienceType;
        this.pageTitle = 'Podcasts';

        this.shows = await this.showsService.all();
        this.shows = this.shows.filter(p => p.enable_podcasting);

        if (this.shows.length > 0) {
            this.bgImageToUse = this.shows[0].web_header_image;
        }
    }
}
